/**
 * @module actions/messages
 */
import axios from 'axios'
import { API_URL, FILE_STORAGE_API } from '../constants'

/**
 * @description Get punch clock stats
 * @return {Promise} Axios promise
 */
export function getPunchStats () {
  let url = API_URL + '/PunchClock/GetPunch/'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get punch clock stats for current user
 * @return {Promise} Axios promise
 */
export function getPunchStatsCurrentUser () {
  let url = API_URL + '/PunchClock/GetPunchUser/'
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Edit punch clock stats
 * @return {Promise} Axios promise
 */
export function editPunchStats (data) {
  let url = API_URL + '/PunchClock/Punch/'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get punch clock stats
 * @return {Promise} Axios promise
 */
export function getUserPunchStats (data) {
  let url = API_URL + '/PunchClock/GetUserStats/'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get punch clock stats for a specific user
 * @return {Promise} Axios promise
 */
export function getPunchClockStats (id) {
  let url = API_URL + '/PunchClock/UserPunchStats/' + id
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Retrieves a time report for punch times, for a specific user in a specific time range
 * @return {Promise} Axios promise
 */
export function getShopPunchTimeReport (userId, fromDateTime, toDateTime) {
  let url = API_URL + '/Shop/Reports/PunchTimes'
  let data = {
    UserId: userId,
    FromTime: fromDateTime,
    ToTime: toDateTime
  }
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Get punch times for employee
 * @return {Promise} Axios promise
 */
export function getEmployeePunchTimes (userId, fromDateTime, toDateTime) {
  let url = API_URL + '/Shop/Reports/EmployeePunchTimes'
  let data = {
    UserId: userId,
    FromTime: fromDateTime,
    ToTime: toDateTime
  }
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Edit punch times for employee
 * @return {Promise} Axios promise
 */
export function editEmployeePunchTimes (data) {
  let url = API_URL + '/Shop/Reports/EmployeePunchTimesPost'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Multiple punch times
 * @return {Promise} Axios promise
 */
export function getMultipleShopPunchTimeReport (data) {
  let url = FILE_STORAGE_API + '/Shop/Reports/MultiplePunchTimes'
  return dispatch => {
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/punchclock.js